import { createConsts, createActions } from '../../utils/redux';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

export const consts = createConsts(
  'ui',
  'sidebar',
  'TOGGLE_VISIBILITY',
  'SET_DESKTOP_VISIBILITY',
);
export const actions = createActions(consts);

const initialState = {
  visible: false,
  desktopVisible: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: !state.visible,
      };
    case consts.SET_DESKTOP_VISIBILITY:
      return {
        ...state,
        desktopVisible: action.payload,
      };
    case LOCATION_CHANGE:
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/sidebar.js